// @core/api/endpoints/payment/attach_payment_method_to_legal_entity.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  AttachPaymentMethodToLegalEntityRequest,
} from '../../../types/payment';

const BASE_PATH = '/payment';

/**
 * Attach payment method to legal entity
 * Links a PaymentMethodDetail to a LegalEntity for contract-rendering. Usually the link is implicit via BillingAccount.legal_entity_ref, but this RPC sets it directly on the method for overrides where the bank account belongs to a different legal entity than the billing account's default.
 */
export async function AttachPaymentMethodToLegalEntity(
  paymentMethodId: string,
  data: AttachPaymentMethodToLegalEntityRequest,
  options?: RequestOptions
): Promise<Response> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/payment-methods/:paymentMethodId/legal-entity`;
  requestPath = requestPath.replace(':paymentMethodId', encodeURIComponent(paymentMethodId));
  const requestOptions = options;
  return client.post<Response>(requestPath, data, requestOptions);
}
